export default {
	title: 'night_mode',
	components: [{ title: 'night_mode', component: 'night_mode' }],
};
